import { call, put, delay } from "redux-saga/effects";
import { userApi } from "@services/api";
import { changePasswordActions } from "../slices";
import {
  rejectLoadingToast,
  resolveLoadingToast,
  startLoadingToast,
} from "@helpers";
import { logoutAction } from "@redux/actions";

function* changePasswordWorker({ payload }) {
  const toastId = startLoadingToast("Changing your password");
  yield put(changePasswordActions.pending());
  yield delay(300);
  try {
    const response = yield call(userApi.changePassword, payload);
    yield put(changePasswordActions.success(response));
    resolveLoadingToast(
      toastId,
      "Change password successfully, you'll be signed out in a second."
    );
    yield delay(5000);
    yield put(logoutAction());
    // TODO: handle callback | onSuccess
  } catch (error) {
    yield put(changePasswordActions.failure({ ...error, toastId }));
    rejectLoadingToast(toastId, "Change password failed");
    // TODO: handle callback | onFailure
  }
}

export { changePasswordWorker };
